<template>
  <b-modal size="lg" v-model="show" centered title="Stammauftrag wählen"
           >
    <b-row>
      <b-col style="padding-left: 20px; padding-right: 20px">
        <p><b>Gruppe wählen</b></p>
      </b-col>
      <b-col style="padding-left: 20px; padding-right: 20px">
      <p><b>Auftrag wählen</b></p>
    </b-col>
    </b-row>
    <b-row>
      <b-col style="height: 55vh; overflow: auto">
        <b-table thead-class="display_none" striped hover selectable :items="groups" :fields="groupFields"
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelectedGroup"
                 ref="group_table"
        >

        </b-table>
      </b-col>
      <b-col style="height: 55vh; overflow: auto">
        <b-table thead-class="display_none" striped hover :items="objects" :fields="objectFields" selectable
                 select-mode="single"
                 selectedVariant="primary"
                 @row-selected="rowSelectedObject"
                 ref="object_table"
        >
        </b-table>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" :disabled="!canContinue" variant="success" @click="onSelected">
        Annehmen
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";

export default {
  name: "SelectAufisnDialog",
  data() {
    return {
      show: false,
      loader: undefined,
      currentGroup: {},
      groups: [],
      objects: undefined,
      objectsMap: {},
      group_fields: [{key: "titel", label: 'Gruppe wählen'}, {key: "map", label: ""}],
      object_fields: [{key: "gi_match", label: 'Objekt wählen'}, {key: "gps", label: ""}],
      selected: [],
      changeTitles: false,
      allowEmpty: false,
    }
  },
  computed: {
    canContinue() {
      return this.selected.length > 0 || this.allowEmpty;
    },
    groupFields() {
      if (!this.changeTitles) {
        return this.group_fields;
      } else {
        return [{key: "name", label: 'Gruppe wählen'}]
      }
    },
    objectFields() {
      if (!this.changeTitles) {
        return this.object_fields;
      } else {
        return [{key: "object", label: 'Objekt wählen'}]
      }
    }
  },
  methods: {
    onSelected() {
      this.show = false;
      this.$emit("aufisn-selected", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog(groups, objectsMap, allowEmpty = false) {
      this.allowEmpty = allowEmpty;
      this.objects = undefined;
      this.selected = [];
      this.currentGroup = {};
      this.show = true;
      if (groups && objectsMap) {
        this.changeTitles = true;
        let g = JSON.parse(JSON.stringify(groups));
        for (let i = 0; i < g.length; i++) {
          g[i].key = g[i].gischl;
        }
        this.groups = g;
        this.objectsMap = objectsMap;
      }
      if (this.groups.length === 0) {
        this.showLoader();
        this.$http.get(
            Server_URL+'/auftragsbuch/data/create/augrs_aufisns'
        ).then(this.responseOkGet, this.responseError)
      }
    },
    rowSelectedGroup(items) {
      if (items.length === 0) {
        this.objects = undefined;
        this.selected = [];
        this.currentGroup = {};
      } else {
        this.objects = this.objectsMap[items[0].key];
        this.currentGroup = items[0];
        if (this.objects.length === 1) {
          this.$nextTick(() => {
            this.$refs.object_table.selectRow(0);
          });
        }
      }
    },
    rowSelectedObject(items) {
      this.selected = items;
    },

    getReturnData: function () {
      return {
        selected_augr: this.selected.length ? this.currentGroup : null,
        selected_aufisn: this.selected.length ?  this.selected[0] : null,
      };
    },
    showLoader() {
      //this.loader = this.$loading.show();
    },
    hideLoader() {
      /*if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }*/
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200 && response.body.status === "ok") {
        for (let i = response.body.data.augrs.length-1; i >= 0; i--) {
          if (response.body.data.aufisn_map[response.body.data.augrs[i].key] === undefined) {
            response.body.data.augrs.splice(i, 1)
          }
        }
        this.groups = response.body.data.augrs;
        this.objectsMap = response.body.data.aufisn_map;
        this.gpsMap = response.body.data.gps_map;
        this.geoRefPerimeter = response.body.data.geo_ref_perimeter;
        if (this.groups.length === 1) {
          this.$nextTick(() => {
            this.$refs.group_table.selectRow(0);
          });
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
  }
}
</script>

<style>
.display_none {
  display: none;
}

.form-control:disabled {
  color: black;
}

.text-black {
  color: black;
}
</style>
